import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "@/lib/api";

const messages = [
  "🚚  Free Shipping on orders above ₹999",
  "🎁  Buy 2 Get 1 Free — Gift Sets",
  "🔥  Limited Edition Winter Collection is here",
];

export function AnnouncementBar() {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    staleTime: 5 * 60 * 1000, // 5 min — don't refetch on every render
    queryFn: async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 4000);
      try {
        const res = await fetch(`${API_BASE_URL}/api/settings`, { signal: controller.signal });
        clearTimeout(timer);
        if (res.ok) return await res.json();
      } catch (err: any) {
        clearTimeout(timer);
        // silent fallback
      }
      return null;
    }
  });

  const activeMessages = settings?.announcements || messages;

  return (
    <div className="h-10 bg-primary text-[color:var(--gold)] text-xs tracking-[0.2em] uppercase flex items-center justify-center overflow-hidden">
      <div className="flex items-center gap-16 whitespace-nowrap animate-[marquee_28s_linear_infinite]">
        {[...activeMessages, ...activeMessages, ...activeMessages].map((m, i) => (
          <span key={i} className="font-medium">{m}</span>
        ))}
      </div>
    </div>
  );
}